import * as dompack from 'dompack';
import { $, Element, Class, typeOf } from "@webhare-system/frameworks/mootools/core";

var TagEdit = require('../components/tagedit/tagedit');

var $todd = require("./support");
var domtools = require('@webhare-system/dom/tools');
var domui = require('@webhare-system/internal/legacyui');
var DateField = require('../components/basecontrols/calendar2');
var TimeField = require('../components/basecontrols/time');
import { InputTextLengthCounter } from "../components/basecontrols/counter";
var Slider = require('../components/basecontrols/slider');
var KeyboardBunny = require("@webhare-system/dom/keyboard");
var legacybase = require('@webhare-system/internal/legacybase');
var Checkbox = require('../components/basecontrols/checkbox');
var Radiobutton = require('../components/basecontrols/radiobutton');
var autocomplete = require("@webhare-system/internal/autocomplete");
var toddImages = require("./images");

/****************************************************************************************************************************
 *                                                                                                                          *
 *  TEXT                                                                                                                    *
 *                                                                                                                          *
 ****************************************************************************************************************************/


$todd.ObjText = new Class(
{ Extends: $todd.ObjLayout
, Properties: [ "labelFor" ] // Adds "labelfor" property and "getLabelFor" and "setLabelFor" accessors
, componenttype: "text"

, styles: null
, transparenttoclicks: false
, sethtml: false
, recreatenode: false
, isheading: false
, ismouseselectable: false
, linkactions: []
/****************************************************************************************************************************
* Initialization
*/

, initialize: function(parentcomp, data, replacingcomp)
  {
    this.parent(parentcomp, data, replacingcomp);

    this.transparenttoclicks = data.transparenttoclicks;

    this.setLabelFor(data.labelfor);

    this.setStyles(data);
    this.isheading = !!data.isheading;
    this.action = data.action;

    this.ismouseselectable = data.selectable;
    this.linkactions = data.linkactions || [];

    this.setInterestingActions([this.action]);
    this.setValue(data.value, data.ishtml);
  }

, setStyles: function(settings)
  {
    if (!this.styles)
    {
      this.styles = { bold:      false
                    , italic:    false
                    , underline: false
                    , wordwrap:  false
                    , ellipsis:  false
                    };
    }

    Object.each(this.styles, function(value, key)
    {
      if (typeOf(settings[key]) == typeOf(this.styles[key]))
        this.styles[key] = settings[key];
    }, this);
  }


/****************************************************************************************************************************
* Property getters & setters
*/

, setLabelFor: function(value)
  {
    this.labelfor = value;
  }

, setValue: function(value, ishtml)
  {
    this.value = value;
    this.sethtml = !!ishtml;
    this.buildNode();
    if(!this.styles.ellipsis)
      this.width.dirty=true;
  }


/****************************************************************************************************************************
* DOM
*/

, buildNode:function()
  {
    var txtnode = new Element("t-text", { "data-name": this.name
                                        });
    if (this.isheading)
      txtnode.classList.add("heading");
    if(this.sethtml)
      txtnode.set('html', this.value);
    else this.value.split('\n').each(function (textrow, idx)
      {
        if(idx>0)
          txtnode.appendChild(new Element("br"));
        txtnode.appendText(textrow);
      });

    if(this.hint)
      txtnode.set('title',this.hint);

    if(this.ismouseselectable)
      txtnode.classList.add("selectable");

    if(this.styles.bold)
      txtnode.setStyle("font-weight","bold");
    if(this.styles.italic)
      txtnode.setStyle("font-style","italic");
    if(this.styles.underline)
      txtnode.setStyle("text-decoration","underline");
    if (this.labelfor || this.action)
      txtnode.classList.add("label");
    else
    {
      if (this.styles.wordwrap)
        txtnode.classList.add("wrapped");
      if (this.styles.ellipsis)
        txtnode.classList.add("ellipsis");
    }

    if(!this.transparenttoclicks)
      txtnode.addEvent("click", this.onClick.bind(this));

    txtnode.store("todd", this);

    this.nodesize = $todd.CalculateSize(txtnode);

    if(this.styles.ellipsis) //don't set width if ellipsis is applied
      this.nodesize.x = 0;

    if(this.node && this.node.parentNode)
    {
      this.node.parentNode.replaceChild(txtnode, this.node);
      this.node = txtnode;
    }
    else
      this.node = txtnode;
    return txtnode;
  }


/****************************************************************************************************************************
* Dimensions
*/

, calculateDimWidth: function()
  {
//    var width = $todd.ReadSetWidth(this.width);
//    var wrapwidth = this.styles.wordwrap || this.styles.ellipsis ? Math.max(1, width) : 0;

//    var contentwidth = $todd.CalculateTextSize(this.node.get(this.sethtml?'html':'text'), wrapwidth, this.node.getStyles($todd.GetCalculateTextStyles()), this.sethtml).x;
    this.width.calc = this.nodesize.x;
    this.width.min = this.width.calc;
  }

, applySetWidth:function()
  {
    this.debugLog("dimensions", "width min=" + this.width.min + ", calc=" + this.width.calc + ", set=" + this.width.set);
    this.node.setStyle("width", this.width.set);
    this.updateNodeSizeData();
  }

, getSkinSettings: function()
  {
    return { margintop: this.node.getStyle("margin-top").toInt()
           };
  }

, calculateDimHeight: function()
  {
    //this.height.min = Math.max($todd.UpToGridsize(this.node.getSize().y, $todd.settings.grid_vsize), $todd.settings.grid_vsize);
    this.height.min = Math.max(this.node.getSize().y + this.skinsettings.margintop, $todd.settings.grid_vsize);
  }

, relayout: function()
  {
    this.debugLog("dimensions", "relayouting set width=" + this.width.set + ", set height="+ this.height.set);
    this.node.setStyles({ width: this.width.set
                        , height: this.height.set - this.skinsettings.margintop
                        //, "margin-left": this.width.marginbefore
                        });

    if (this.styles.ellipsis)
      this.node.toggleClass('overflow', this.width.set < this.width.min || this.height.set < this.height.min);
  }


/****************************************************************************************************************************
* Events
*/

, applyUpdate: function(data)
  {
    switch(data.type)
    {
      case "value":
        this.setValue(data.value, data.ishtml);
        return;
    }
    this.parent(data);
  }

, onClick: function(event)
  {
    var anchor = dompack.closest(event.target, 'a');
    if(anchor)
    {
      var rec = this.linkactions.getByProperty("url", anchor.href);
      if (rec)
        this.owner.executeAction(rec.action);
      else if(this.isEventUnmasked("clicklink"))
        this.queueEvent(this.owner.screenname + "." + this.name, 'clicklink ' + anchor.href, true);
      else if(anchor.href.substr(0,7) == 'mailto:')
        return; //let it be, follow the link. the only exit which does _not_ event.stop...
      else if(anchor.href.substr(0,11) != 'javascript:')
        window.open(anchor.href,'_blank');

      event.stop();
      return;
    }
    event.stop();

    if(this.action)
      this.owner.executeAction(this.action);

    var comp = this.owner.getComponent(this.labelfor);
    if (comp)
    {
      comp.node.focus();
      comp.node.click();
      console.log(comp, document.activeElement);
    }
  }

, onTooltip: function(node)
  {
    if (!this.styles.wordwrap && !this.styles.ellipsis && this.width.set < this.width.calc)
      return this.node.get('text');
  }

});



$todd.ObjTextEdit = new Class(
{ Extends: $todd.ObjLayout
, Properties: [ "required" ]
, componenttype: "textedit"
, lastreportedvalue: ''
, reportchange_cb: null

, showcounter: false
, maxlength: 0
, autocomplete: null
, maxlengthmeasure: false
, type: ''
, inputnode: null
, placeholder: ''
, buttons: []

  // ---------------------------------------------------------------------------
  //
  // Initialization
  //

, initialize: function(parentcomp, data, replacingcomp)
  {
    this.parent(parentcomp, data, replacingcomp);
    this.setValue(data.value);
    this.placeholder = data.placeholder || "";
    this.showcounter = data.showcounter === true;
    this.maxlength = 0;
    this.maxlengthmeasure = data.maxlengthmeasure;
    if (data.maxlength >= 0 && !data.password) //Never accept a maxlength on passwords, as it's not obvious you typed too much characters
      this.maxlength = data.maxlength;

    this.type = data.password ? 'password' : 'text';

    this.buttons = [];
    if (data.buttons)
      data.buttons.forEach(button =>
      {
        var comp = this.owner.addComponent(this, button);
        this.buttons.push(comp);
      });

    // Build our DOM
    this.buildNode();

    this.inputnode.addEvent("focus", this.onFocus.bind(this));
    this.inputnode.addEvent("input", this.onAnyChange.bind(this));

    this.setRequired(data.required);
    this.setEnabled(data.enabled);

    if (data.options)
    {
      var values = data.options.map(function(item) { return { value: item.title }; });
      this.autocomplete = new autocomplete.AutoCompleteStaticList(
          { values: values
          , maxresults: values.length
          });
    }
    else if (data.ac_port)
    {
      this.autocomplete = new $todd.AutoCompleteService(data);
    }

    if (this.autocomplete)
      autocomplete.AutoComplete.addToInput(this.inputnode, this.autocomplete);
  }

/****************************************************************************************************************************
* Component management
*/

, readdComponent: function(comp)
  {
    // Replace the offending component
    //if(!comp.parentsplititem)
    if(comp.parentcomp != this)
      return console.error('Child ' + comp.name + ' not inside the textedit is trying to replace itself');

    var newcomp = this.owner.addComponent(this, comp.name);
    this.buttons.splice(this.buttons.indexOf(comp), 1, newcomp);
    dompack.replaceWith(comp.getNode(), newcomp.getNode());
  }

  // ---------------------------------------------------------------------------
  //
  // Helper functions
  //

  /// Called after little timout to detect changes in value
, _reportChangesCallback: function()
  {
    this.reportchange_cb = null;

    // Get the current value, compare with last reported value
    var currentvalue = this.getValue();
    if (this.lastreportedvalue != currentvalue && this.isEventUnmasked('change'))
    {
      // Only update lastreportedvalue when we're actually reporting.
      this.lastreportedvalue = currentvalue;
      this.transferState(false);
    }
  }

  // ---------------------------------------------------------------------------
  //
  // Property getters & setters
  //

, getSubmitValue: function()
  {
    // Get value to report. Also update lastreportedvalue, the backend now knows our value
    var value = this.getValue();
    this.lastreportedvalue = value;
    return value;
  }

, getValue: function()
  {
    return this.inputnode ? this.inputnode.get("value") : this.value;
  }

, setValue: function(value)
  {
    if (value != this.value)
    {
      this.value = value;
      if (this.inputnode)
        this.inputnode.set("value", this.value);
    }

    // Always update the last reported value, this instruction came from the backend
    this.lastreportedvalue = value;
  }

, setRequired: function(value)
  {
    if (value != this.required)
    {
      this.required = value;
      this.node.toggleClass("required", this.required);
    }
  }

, setEnabled: function(value)
  {
    if (value == this.enabled)
      return;

    this.enabled = value;
    this.node.toggleClass("disabled", !this.enabled);
    this.inputnode.set("readOnly", !this.enabled);
    this.inputnode.setAttribute("tabindex", this.enabled ? 0 : -1);
  }

  // ---------------------------------------------------------------------------
  //
  // DOM
  //

  // Build the DOM node(s) for this component
, buildNode: function()
  {
    this.node = new Element("t-textedit", { "data-name": this.name
                                          });
    this.node.store("todd", this);

    if(this.hint)
      this.node.set('title',this.hint);

    this.inputnode = new Element("input", { value: this.getValue()
                                          , type:  this.type
                                          , placeholder: this.placeholder.split("\n").join(", ")
                                          , autocapitalize: "off"
                                          , autocomplete: "off"
                                          }).inject(this.node);
    if (this.maxlength > 0)
      this.inputnode.set("maxLength", this.maxlength);

    if(this.showcounter)
      new InputTextLengthCounter(this.node, { 'maxlengthmeasure' : this.maxlengthmeasure });

    for (let button of this.buttons)
      this.node.appendChild(button.getNode());
  }

  // ---------------------------------------------------------------------------
  //
  // Dimensions
  //

, getVisibleChildren: function()
  {
    return this.buttons;
  }

, getSkinSettings: function()
  {
    var styles = this.inputnode.getStyles([ "border-left-width", "border-right-width"
                                          , "padding-left", "padding-right"
                                          , "height", "min-height"
                                          , "margin-top"
                                          ]);
    return { x_overhead: styles["border-left-width"].toInt() + styles["border-right-width"].toInt() + styles["padding-left"].toInt() + styles["padding-right"].toInt()
           , height: styles["height"].toInt() || 0
           , minheight: styles["min-height"].toInt() || 0
           , padding: styles["padding-right"].toInt() || 0
           };
  }

, calculateDimWidth: function()
  {
    this.width.min = $todd.desktop.x_width*2 + this.skinsettings.x_overhead;
    this.buttons.forEach(button =>
    {
      button.width.min = 16;
      button.width.calc = 16;
      this.width.min += this.skinsettings.padding + button.width.calc;
    });
    this.width.calc = Math.max(this.width.min, $todd.settings.textedit_defaultwidth);
  }

, applySetWidth: function()
  {
    this.buttons.forEach(button =>
    {
      button.setWidth(button.width.calc);
    });
  }

, calculateDimHeight: function()
  {
    this.height.min = $todd.settings.grid_vsize;
    this.buttons.forEach(button =>
    {
      button.height.min = 16;
      button.height.calc = 16;
    });
  }

, applySetHeight: function()
  {
    this.buttons.forEach(button =>
    {
      button.setHeight(button.height.calc);
    });
  }

, relayout: function()
  {
    this.debugLog("dimensions", "relayouting set width=" + this.width.set + ", set height="+ this.height.set);
    let padding = this.skinsettings.padding;
    for (let idx = this.buttons.length - 1; idx >= 0; --idx)
    {
      let button = this.buttons[idx];
      this.buttons.forEach(button => button.getNode().style.right = padding + "px");
      padding += this.skinsettings.padding + button.width.set;
      button.relayout();
    }
    this.inputnode.setStyles({ width:  this.width.set
                             , "padding-right": padding
                             });
  }


  // ---------------------------------------------------------------------------
  //
  // Events
  //

, onShow: function()
  {
    // Set placeholder just before showing the field, so our custom placeholder will be positioned correctly
    this.inputnode.set("placeholder", this.placeholder);
    return true;
  }

, onFocus: function()
  {
    this.owner.setComponentDefaultButton(this);
  }

, onAnyChange: function()
  {
    // Run change detect handler 100ms after last successive change
    if (this.reportchange_cb)
      clearTimeout(this.reportchange_cb);

     this.reportchange_cb = setTimeout( () => this._reportChangesCallback(), 100);
  }
});


/****************************************************************************************************************************
 *                                                                                                                          *
 *  DATETIME                                                                                                                *
 *                                                                                                                          *
 ****************************************************************************************************************************/
$todd.ObjDateTime = new Class(
{ Extends: $todd.ObjLayout
, Properties: [ "required" ]
, componenttype: "datetime"
, datefield: null
, timefield: null
, lasterportedvalue: null

/****************************************************************************************************************************
* Initialization
*/

, initialize: function(parentcomp, data, replacingcomp)
  {
    this.parent(parentcomp, data, replacingcomp);
    this.type=data.type;
    this.precision=data.precision;

    // Build our DOM
    this.fieldtype = data.fieldtype;
    this.placeholder = data.placeholder;
    this.dateformat = data.dateformat;
    this.buildNode(data);
    this.lastreportedvalue = "0000-00-00T00:00:00.000Z";
    this.setValue(data.value);

    this.node.addEventListener("change", this._reportChangesCallback.bind(this));

    this.setRequired(data.required);
    this.setEnabled(data.enabled);
  }

  // ---------------------------------------------------------------------------
  //
  // Helper functions
  //

, _padLeft: function(data, len)
  {
    data = '0000' + data;
    return data.substr(data.length - Math.max(data.length - 4, len));
  }

, _reportChangesCallback: function(event)
  {
    // Get the current value, compare with last reported value
    var currentvalue = this.getValue();
    if (this.lastreportedvalue != currentvalue)// && this.isEventUnmasked('change'))
    {
      // Only update lastreportedvalue when we're actually reporting.
      this.lastreportedvalue = currentvalue;

      this.queueEvent(this.owner.screenname + "." + this.name, "select", false);
    }
  }

  /** Store the value in the node, no callbacks
  */
, _setValueInternal: function(value)
  {
    var dateval='', timeval='';
    var tpos = value.indexOf('T');
    if(value && this.datefield)
    {
      var year = parseInt(value.substr(0, tpos - 4),10);
      var month = parseInt(value.substr(tpos - 4, 2),10);
      var day = parseInt(value.substr(tpos - 2, 2),10);

      //Just plain db format
      dateval = (year < 1000 ? ("000"+year).slice(-4) : year) + "-" + ("0"+month).slice(-2) + "-" +  ("0"+day).slice(-2);
    }

    if(value && this.timefield)
    {
      var hour = parseInt(value.substr(tpos + 1,2),10);
      var min = parseInt(value.substr(tpos + 3,2),10);
      var sec = parseInt(value.substr(tpos + 5,2),10);
      var msec = parseInt(value.substr(tpos + 7,3),10);

      timeval = ("0"+hour).slice(-2) + ":" + ("0"+min).slice(-2);
      if(this.precision=='seconds' || this.precision=='milliseconds')
        timeval += ':' + ("0"+sec).slice(-2);
      if(this.precision=='milliseconds')
        timeval += '.' + ("00"+msec).slice(-3);
    }

    if(this.datefield)
      this.datefield.set("value", dateval);
    if(this.timefield)
      this.timefield.set('value', timeval);
  }

/****************************************************************************************************************************
* Property getters & setters
*/

, getSubmitValue: function()
  {
    return this.getValue();
  }

, getValue: function()
  {
    var retval;
    var defaultdate = true;
    if(this.datefield) //FIXME support dateformat, validate
    {
      var datevalue = this.datefield.get('value');
      retval = '0000-00-00';
      let parts = datevalue.replace(/\//g,'-').split('-');
      if (parts.length == 3)
      {
        retval = this._padLeft(parts[0],4) + '-' + this._padLeft(parts[1],2) + '-' + this._padLeft(parts[2],2);//Just plain db format
        defaultdate = false;
      }
    }
    else
    {
      retval = '0001-01-01'; //ensure valid datetime if just sending time
    }
    retval += 'T';
    if(this.timefield)
    {
      // FIXME: parse correctly!!!!
      var timevalue = this.timefield.get('value');
      if (!timevalue && defaultdate)
        return "";
      let parts = timevalue.replace(/\./g,':').split(':');
      if (parts.length >= 2)
        retval += this._padLeft(parts[0],2) + ':' + this._padLeft(parts[1],2);
      else
        retval += '00:00';

      if ((this.precision=='seconds' || this.precision=='milliseconds') && parts.length >= 3)
        retval += ':' + this._padLeft(parts[2],2);
      else
        retval += ':00';

      if(this.precision=='milliseconds' && parts.length >= 4)
        retval += '.' + (parts[3]+'000').substr(0,3);
      else
        retval += '.000';
    }
    else
    {
      if (defaultdate)
        return "";
      retval += '00:00:00.000';
    }
    retval += 'Z';
    return retval;
  }
  /// Set the value. Report back changes when the value has changed
, setValue: function(value)
  {
    var oldval = this.getValue();
    this._setValueInternal(value);

    if (oldval !== this.getValue())
      this._reportChangesCallback();
  }
, setRequired: function(value)
  {
    if (value != this.required)
    {
      this.required = value;
      this.node.toggleClass("required", this.required);

      if (this.datefield)
      {
        this.datefield.required = this.required;
        this.datefield.fireEvent("wh-refresh");
      }

      if (this.timefield)
      {
        this.timefield.required = this.required;
        this.timefield.fireEvent("wh-refresh");
      }
    }
  }

, setEnabled: function(value)
  {
    if (value != this.enabled)
    {
      this.enabled = value;
      this.node.toggleClass("disabled", !this.enabled);

      if (this.datefield)
      {
        this.datefield.disabled = this.enabled ? null : "disabled";
        this.datefield.fireEvent("wh-refresh");
      }
      if (this.timefield)
      {
        this.timefield.disabled = this.enabled ? null : "disabled";
        this.timefield.fireEvent("wh-refresh");
      }
    }
  }


/****************************************************************************************************************************
* DOM
*/

   // Build the DOM node(s) for this component
, buildNode: function(data)
  {
    this.node = new Element("t-datetime", { "data-name": this.name
                                          });
    if(this.hint)
      this.node.set('title',this.hint);
    this.node.store("todd", this);
    if(this.fieldtype == 'date' || this.fieldtype=='datetime')
    {
      this.datefield = new Element("input",{ "type" : "date", "class": "date", "placeholder" : this.placeholder, "data-format": this.dateformat }).inject(this.node);
      this.datefield.required = data.required;
      this.datefield.disabled = this.enabled ? null : "disabled";
      this.datefield.fireEvent("wh-refresh");
    }
    if(this.fieldtype == 'datetime')
    {
      new Element("span",{ "html" : "&nbsp;" }).inject(this.node);
    }
    if(this.fieldtype == 'time' || this.fieldtype=='datetime')
    {
      var placeholder = "00:00";
      var step = "60"; // minutes
      if (this.precision=='seconds' || this.precision=='milliseconds')
      {
        placeholder += ":00";
        step = "1"; // seconds
      }
      if (this.precision=='milliseconds')
      {
        placeholder += ".000";
        step = ".001"; // milliseconds
      }

      this.timefield = new Element("input",{ "type": "time", "class": "time", "placeholder": placeholder, "step": step }).inject(this.node);
      this.timefield.required = data.required;
      this.timefield.disabled = this.enabled ? null : "disabled";
      this.timefield.fireEvent("wh-refresh");
    }
  }


/****************************************************************************************************************************
* Dimensions
*/

, calculateDimWidth: function()
  {
    if(!this.minwidth)
      this.minwidth = this.node.getSize().x;

    this.width.min = this.width.calc = this.minwidth;
  }

, calculateDimHeight: function()
  {
    this.height.min = this.height.calc = $todd.desktop.x_height;
  }

, relayout: function()
  {
  }


});

/****************************************************************************************************************************
 *                                                                                                                          *
 *  TEXTAREA                                                                                                                *
 *                                                                                                                          *
 ****************************************************************************************************************************/

$todd.ObjTextArea = new Class(
{ Extends: $todd.ObjLayout
, Properties: [ "required" ]
, componenttype: "textarea"

/****************************************************************************************************************************
* Initialization
*/

, initialize: function(parentcomp, data, replacingcomp)
  {
    this.parent(parentcomp, data, replacingcomp);
    this.setValue(data.value);
    this.placeholder = data.placeholder || "";
    this.showcounter = data.showcounter === true;
    this.maxlength = 0;
    this.maxlengthmeasure = data.maxlengthmeasure;
    if (data.maxlength >= 0 && !data.password) //Never accept a maxlength on passwords, as it's not obvious you typed too much characters
      this.maxlength = data.maxlength;

    // Build our DOM
    this.buildNode();

    new KeyboardBunny(this.node, {}, { dontpropagate: ['Enter']});

    this.setRequired(data.required);
    this.setEnabled(data.enabled);
  }


/****************************************************************************************************************************
* Property getters & setters
*/

, getSubmitValue: function()
  {
    return this.getValue();
  }

, getValue: function()
  {
    return this.inputnode ? this.inputnode.get("value") : this.value;
  }

, setValue: function(value)
  {
    if (value != this.value)
    {
      this.value = value;
      if (this.inputnode)
        this.inputnode.set("value", this.value);
    }
  }

, setRequired: function(value)
  {
    if (value != this.required)
    {
      this.required = value;
      this.node.toggleClass("required", this.required);
    }
  }

, setEnabled: function(value)
  {
    if (value != this.enabled)
    {
      this.enabled = value;
      this.node.toggleClass("disabled", !this.enabled);
      this.inputnode.set("readOnly", !this.enabled);
    }
  }


/****************************************************************************************************************************
* DOM
*/

  // Build the DOM node(s) for this component
, buildNode: function()
  {
    this.node = new Element("t-textarea", { "data-name": this.name
                                          });
    this.node.store("todd", this);
    if(this.hint)
      this.node.set('title',this.hint);
    this.inputnode = new Element("textarea", { text: this.getValue()
                                             , autocapitalize: "off"
                                             , autocomplete: "off"
                                             , placeholder: this.placeholder.split("\n").join(", ")
                                             }).inject(this.node);

    if (this.maxlength > 0)
      this.inputnode.set("maxLength", this.maxlength);

    if(this.showcounter)
      new InputTextLengthCounter(this.node, { 'maxlengthmeasure' : this.maxlengthmeasure });

  }

/****************************************************************************************************************************
* Dimensions
*/

, calculateDimWidth: function()
  {
    this.width.min = $todd.desktop.x_width*2;
    this.width.calc = $todd.ReadSetWidth(this.width);
    this.debugLog("dimensions", "calc=" + this.width.calc + ", min=" + this.width.min);
  }

, calculateDimHeight: function()
  {
    this.height.min = $todd.settings.grid_vsize * 2;
  }

, relayout: function()
  {
    this.debugLog("dimensions", "relayouting set width=" + this.width.set + ", set height="+ this.height.set);
    this.inputnode.setStyles({ width: this.width.set
                             , height: this.height.set - 5
                             });
  }

/****************************************************************************************************************************
* Events
*/

, onShow: function()
  {
    // Set placeholder just before showing the field, so our custom placeholder will be positioned correctly
    this.inputnode.placeholder = this.placeholder;
    return true;
  }

});

/****************************************************************************************************************************
 *                                                                                                                          *
 *  BUTTON                                                                                                                  *
 *                                                                                                                          *
 ****************************************************************************************************************************/


$todd.ObjButton = new Class(
{ Extends: $todd.ObjLayout
, componenttype: "button"
, iconsize: 0
, menuopen:false
, ismenubutton: false
, isactive:false

/****************************************************************************************************************************
 * Initialization
 */

, initialize: function(parentcomp, data, replacingcomp)
  {
    this.parent(parentcomp, data, replacingcomp);
    this.setTitle(data.title);

    this.action = data.action;
    this.setInterestingActions([this.action]);

    this.icon = data.icon;
    this.type = data.buttontype; // "standard" or "icon"
    this.showdefaultbutton = false;
    this.pressed = data.ispressed || false;
    this.ismenubutton = data.ismenubutton;

    // Build our DOM
    this.buildNode();
    this.setMenu(data.menu);

    new KeyboardBunny(this.node, { " ": this.onClick.bind(this)
                                 , "Enter": this.onClick.bind(this)
                                 }, {stopmapped: true} );

    this.setEnabled(data.enabled);
  }
, setMenu:function(newmenu)
  {
    //this.menu = this.owner.addComponent(this, newmenu);
    //dompack.toggleClasses (this.node, { showmenu: this.isToolbarButton() && this.menu });
    this.menuname = newmenu;
    dompack.toggleClasses (this.node, { showmenu: this.isToolbarButton() && this.menuname });
  }
/****************************************************************************************************************************
 * Property getters & setters
 */

, onActionUpdated:function()
  {
    dompack.toggleClasses(this.node, { disabled: !this.getEnabled() });
  }

, getEnabled: function()
  {
    // Check if the action is already available
    var action = this.action ? this.owner.getComponent(this.action) : null;
    // The button is enabled if it hasn't been disabled directly and it either has an enabled action or no action at all
    return this.enabled && (action ? action.isEnabled() : !this.action);
  }

, setEnabled: function(value)
  {
    this.enabled=value;
    this.node.setAttribute("tabindex", this.getEnabled() && !this.isToolbarButton() ? '0' : '-1');
    this.onActionUpdated();
  }

, setTitle: function(value)
  {
    if (value == this.title)
      return;

    this.title = value;
    if (this.textnode)
      this.textnode.textContent = this.title;
    this.width.dirty = true;
  }

, readdComponent: function(comp)
  {
    // Replace the offending component
    //if(!comp.parentsplititem)
    if(comp.parentcomp != this)
      return console.error('Child ' + comp.name + ' not inside the textedit is trying to replace itself');

    var newcomp = this.owner.addComponent(this, comp.name);
    this.buttons.splice(this.buttons.indexOf(comp), 1, newcomp);

    dompack.replaceWith(comp.getNode(), newcomp.getNode());
  }


/****************************************************************************************************************************
* DOM
*/

, isTabsSpaceButton:function()
  {
    return !!dompack.closest(this.node, 'div.tabs-space');
  }
, isToolbarButton:function()
  {
    return this.parentcomp && this.parentcomp.componenttype=='toolbar';
  }
  // Build the DOM node(s) for this component
, buildNode: function()
  {
    this.node = dompack.create("t-button", { on: { click: evt => this.onClick(evt)
                                                 , mousedown: evt=> this.onMouseDown(evt)
                                                 , mouseup: evt=> this.cancelActiveState(evt)
                                                 , mouseleave: evt=> this.cancelActiveState(evt)
                                                 , "wh:menu-open": evt => this.onMenuState(true, evt)
                                                 , "wh:menu-close": evt => this.onMenuState(false, evt)
                                                 }
                                           , dataset: { name: this.name }
                                           , title: this.hint || ''
                                           , className: { ismenubutton: this.ismenubutton }
                                           });
    this.node.store("todd", this);

    if(this.isToolbarButton())
    {
      this.iconnode = toddImages.createImage(this.icon, $todd.ObjButton.toolbarbutton.width, $todd.ObjButton.toolbarbutton.height, 'w', { className: "button__img" });
      this.node.appendChild(this.iconnode);
      this.textnode = new Element("span", { text: this.title });
      this.node.appendChild(this.textnode);
    }
    else
    {
      if (this.icon)
      {
        if (this.type == "icon")
          this.node.classList.add("icon");

        this.iconsize = 16; //ADDME: Adjust according to button size?
        this.iconnode = toddImages.createImage(this.icon, this.iconsize, this.iconsize, 'b', {className:"button__img"});
        this.node.appendChild(this.iconnode);
      }

      if (this.type != "icon")
      {
        this.textnode = new Element("span", { text: this.title });
        this.node.appendChild(this.textnode);
      }
    }
    dompack.toggleClasses(this.node, { pressed: this.pressed });
  }


/****************************************************************************************************************************
* Dimensions
*/
, getSkinSettings:function()
  {
    if(!this.isToolbarButton())
      return { xpad: legacybase.getHorizontalOverhead(this.node)
             //, ypad: $wh.getVerticalOverhead(this.node)
             };
  }

, calculateDimWidth: function()
  {
    if (this.isToolbarButton())
    {
      var text = this.title;
      var arrow_space = 0;
      if (this.menuname && this.title) // need extra 5 pixels + size of \u25bc char for dropdown symbol (with 70% size)
        arrow_space = 5 + $todd.CalculateTextSize("\u25bc", 0, { "font-size": "70%" }).x;

      let contentwidth = Math.max(65, $todd.CalculateTextSize(text, 0, { "font-size" : 11 }).x + arrow_space) + 8;/* toolbar button text is 11px plus 2*4px padding */
      this.width.min = contentwidth;
      this.width.calc = contentwidth;
      // we can handle the width from CSS, since the toolbar takes up the whole width of the screen
    }
    else
    {
      var width = $todd.ReadSetWidth(this.width);

      // FIXME: nakijken, we hebben toch buttons met icon EN title ????

      //ADDME: If word wrapped, take width into account!
      let contentwidth = 0;

      if (this.type != "icon" && this.title != "") // for buttons of type 'icon' we hide the title
        contentwidth += $todd.CalculateTextSize(this.title).x;

      //console.log("Width", contentwidth, "for title", this.title, " + (skinsettings.xpad)", this.skinsettings.xpad);

      this.width.min  = contentwidth + this.skinsettings.xpad;
      this.width.min = Math.max(this.icon ? this.isTabsSpaceButton() ? 27 : 35 : 84,this.width.min);

      this.width.calc = width + this.skinsettings.xpad;
    }
    if(isNaN(this.width.min))
    {
      console.error(this.name + " failed width calculations!", this.width, this.skinsettings, this.isToolbarButton());
    }
  }

, calculateDimHeight: function()
  {
    if (this.isToolbarButton())
      this.height.min = 56;
    else
      this.height.min = $todd.settings.grid_vsize;
  }

, relayout: function()
  {
    this.debugLog("dimensions", "relayouting set width=" + this.width.set + ", set height="+ this.height.set);
    this.node.style.width = this.width.set + 'px';

    // To prevent rendering the icon at half a pixel (because of text-align: center and odd width) in IE/Edge, reposition the
    // button icon
    if (this.isToolbarButton())
      this.iconnode.style.marginLeft = ((this.width.set/2) - Math.floor(this.width.set/2)) + 'px';
  }


/****************************************************************************************************************************
* Component state
*/

, setDefault: function(isdefault)
  {
    this.node.toggleClass("default", isdefault);
  }


/****************************************************************************************************************************
* Events
*/

, applyUpdate: function(data)
  {
    switch(data.type)
    {
      case "title":
        this.setTitle(data.title);
        return;
      case 'pressed':
        this.pressed = data.pressed;
        this.node.toggleClass('pressed', this.pressed);
        return;
    }
    this.parent(data);
  }

, onClick: function(event)
  {
    if (!this.getEnabled() || event.button)
      return;

    if (this.menuname)
    {
      let menu = this.owner.getComponent(this.menuname);
      if(menu)
      {
        var pos = this.node.getPosition();
        pos.y += this.node.getSize().y;
        this.menunode = menu.openMenuAt(this.node, { direction: 'bottom'
                                                   , align: this.ismenubutton ? 'right' : 'left'
                                                   , ismenubutton: this.ismenubutton
                                                   });
        this.updateActiveState();
      }
      return;
    }
    //ADDME: Differentiate between menu-only buttons and buttons with both an action and a menu. For now, we'll just support
    //       either menu buttons or action buttons.
    if (this.action)
    {
      this.owner.executeAction(this.action);
      return;
    }

    if(this.isEventUnmasked("click"))
    {
      this.queueEvent(this.owner.screenname + "." + this.name, "click", true);
      return;
    }
  }

, onMenuState:function(newstate, event)
  {
    if(event.detail.depth > 1)
      return;

    this.menuopen = newstate;
    this.updateActiveState();
  }

, onMouseDown: function(event)
  {
    event.preventDefault(); // Don't steal focus (FIXME: that not only stop's the default behaviour of getting focus, but also prevents :active from being applied)
    if (!this.getEnabled() || event.rightClick)
      return;

    this.isactive=true;
    this.updateActiveState();
  }
, updateActiveState:function()
  {
    // NOTE: The :active pseudo-class won't work because we have used event.preventDefault() to prevent focus stealing
    dompack.toggleClasses(this.node, { active: this.menuopen || this.isactive });
  }
, cancelActiveState: function(event)
  {
    if (!dompack.allowEventProcessing(event))
      return;

    this.isactive=false;
    this.updateActiveState();
    // FIXME: doesn't reactivate after leaving and reentering the button while keeping the mousebutton down
  }
});


/****************************************************************************************************************************
 * Global button settings
 */

//Toolbar button image dimenions
$todd.ObjButton.toolbarbutton = { width: 24, height: 24}; /* FIXME: Vlaai: is this still necessary? I've added it to the css... */

// ---------------------------------------------------------------------------
//
// Checkbox
//

$todd.ObjCheckbox = new Class(
{ Extends: $todd.ObjLayout
, componenttype: "checkbox"
, flags: []

  // ---------------------------------------------------------------------------
  //
  // Initialization
  //

, initialize: function(parentcomp, data, replacingcomp)
  {
    this.parent(parentcomp, data, replacingcomp);
    this.setValue(data.value);

    this.flags = data.flags || [];

    this.buildNode();

    this.setReadOnly(data.readonly);
    this.setEnabled(data.enabled);
  }

  // ---------------------------------------------------------------------------
  //
  // Communications
  //

, enabledOn: function(checkflags, min, max, selectionmatch)
  {
    return (min > 0 && max != 0 && this.getValue())
           || (min <= 0 && max == 0 && !this.getValue());
  }

  // ---------------------------------------------------------------------------
  //
  // Property getters & setters
  //

, getSubmitValue: function()
  {
    return this.getValue();
  }

, getValue: function()
  {
    return this.control ? this.control.getChecked() : this.value;
  }

, setValue: function(value)
  {
    value=!!value;
    if(value==this.value)
      return;

    this.value = value;
    if (this.control)
      this.control.setChecked(this.value);
  }

, setReadOnly: function(value)
  {
    if (value != this.readonly)
    {
      this.readonly = value;
      this.control.setEnabled(this.enabled && !this.readonly);
    }
  }

, setEnabled: function(value)
  {
    if (value != this.enabled)
    {
      this.enabled = value;
      this.control.setEnabled(this.enabled && !this.readonly);
    }
  }

  // ---------------------------------------------------------------------------
  //
  // DOM
  //

  // Build the DOM node(s) for this component
, buildNode: function()
  {
    this.control = new Checkbox({ checked: this.value
                                , onChange: this.onControlChange.bind(this)
                                });
    this.node = $(this.control);
    if(this.hint)
      this.node.set('title',this.hint);
    this.node.set({ "data-name": this.name
                  });
    this.node.store("todd", this);
  }

  // ---------------------------------------------------------------------------
  //
  // Dimensions
  //

, getSkinSettings: function()
  {
    var styles = this.node.getStyles([ "width", "height" ]);
    return { width: styles["width"].toInt()
           , height: styles["height"].toInt()
           };
  }

, calculateDimWidth: function()
  {
    this.width.calc = this.skinsettings.width;
    this.width.min = this.width.calc;
  }

, calculateDimHeight: function()
  {
    this.height.calc = this.skinsettings.height;
    this.height.min = this.height.calc;
  }

, relayout: function()
  {
    this.debugLog("dimensions", "relayouting set width=" + this.width.set + ", set height="+ this.height.set);
    this.node.setStyles({/* "margin-left": this.width.marginbefore
                        ,*/ "margin-top": this.getVerticalPosition()
                        });
  }

  // ---------------------------------------------------------------------------
  //
  // Component state
  //

, focus: function()
  {
    return true;
  }

, blur: function() {}

  // ---------------------------------------------------------------------------
  //
  // Events & callbacks
  //

, onControlChange: function()
  {
    this.value = this.control.getChecked();
    if(this.isEventUnmasked("change") || this.enablecomponents.length)
      this.queueEvent(this.owner.screenname + "." + this.name, "change", true);
    this.fireEvent("change", this);
    this.owner.actionEnabler();
  }

, applyUpdate: function(data)
  {
    switch(data.type)
    {
      case 'value':
        this.setValue(data.value);
        return;
      case 'enablecomponents':
        this.enablecomponents = data.value;
        return;
    }

    this.parent(data);
  }

});


// ---------------------------------------------------------------------------
//
// Radio button
//

$todd.ObjRadiobutton = new Class(
{ Extends: $todd.ObjLayout
, componenttype: "radiobutton"
, radiogroup: null
, flags: []

  // ---------------------------------------------------------------------------
  //
  // Initialization
  //

, initialize: function(parentcomp, data, replacingcomp)
  {
    this.parent(parentcomp, data, replacingcomp);
    this.setValue(data.value);

    this.radiogroup = data.groupname ? this.owner.screenname + ":" + data.groupname : null;
    this.flags = data.flags || [];

    this.buildNode();

    this.setReadOnly(data.readonly);
    this.setEnabled(data.enabled);
  }

  // ---------------------------------------------------------------------------
  //
  // Property getters & setters
  //

, getSubmitValue: function()
  {
    return this.getValue();
  }

, getValue: function()
  {
    return this.control ? this.control.getChecked() : this.value;
  }

, setValue: function(value)
  {
    if (value !== this.value)
    {
      this.value = value;
      if (this.control)
        this.control.setChecked(this.value);
    }
  }

, setReadOnly(value)
  {
    if (value !== this.readonly)
    {
      this.readonly = value;
      this.control.setEnabled(this.enabled && !this.readonly);
    }
  }

, setEnabled: function(value)
  {
    if (value !== this.enabled)
    {
      this.enabled = value;
      this.control.setEnabled(this.enabled && !this.readonly);
    }
  }

  // ---------------------------------------------------------------------------
  //
  // DOM
  //

  // Build the DOM node(s) for this component
, buildNode: function()
  {
    this.control = new Radiobutton({ checked: this.value
                                       , radiogroup: this.radiogroup
                                       , onChange: this.onControlChange.bind(this)
                                       });
    // onchange handler can only be set after one of the group's radiobuttons is initialized
    if (this.radiogroup)
      Radiobutton.setRadiogroupOnChangeHandler(this.radiogroup, $todd.ObjRadiobutton.onRadiogroupChange);

    this.node = $(this.control);
    if(this.hint)
      this.node.set('title',this.hint);
    this.node.set({ "data-name": this.name
                  });
    this.node.store("todd", this);
  }

  // ---------------------------------------------------------------------------
  //
  // Dimensions
  //

, getSkinSettings: function()
  {
    var styles = this.node.getStyles([ "width", "height" ]);
    return { width: styles["width"].toInt()
           , height: styles["height"].toInt()
           };
  }

, calculateDimWidth: function()
  {
    this.width.calc = this.skinsettings.width;
    this.width.min = this.width.calc;
  }

, calculateDimHeight: function()
  {
    this.height.calc = this.skinsettings.height;
    this.height.min = this.height.calc;
  }

, relayout: function()
  {
    this.debugLog("dimensions", "relayouting set width=" + this.width.set + ", set height="+ this.height.set);
    this.node.setStyles({ /*"margin-left": this.width.marginbefore
                        , */"margin-top": this.getVerticalPosition()
                        });
  }

  // ---------------------------------------------------------------------------
  //
  // Events and callbacks
  //

, onControlChange: function()
  {
    if(!this.owner)
      return; //already deallocated ?

    // This function is called everytime the radiobutton is checked, or when another radiobutton in this group is checked (so
    // we'll have to see if this is the radiobutton that got unchecked)
    var newvalue = this.control.getChecked();
    if (newvalue != this.value)
    {
      this.value = newvalue;
      if((this.isEventUnmasked("set") && this.value) || this.enablecomponents.length)
      {
        console.log("queueEvent "+this.owner.screenname + "." + this.name+"change");
        this.queueEvent(this.owner.screenname + "." + this.name, "change", true);
      }
      this.fireEvent("change", this);
    }
  }

, applyUpdate: function(data)
  {
    switch(data.type)
    {
      case 'value':
        this.setValue(data.value);
        return;
      case 'enablecomponents':
        this.enablecomponents = data.value;
        return;
    }

    this.parent(data);
  }
});

/****************************************************************************************************************************
 * Global radiogroup handlers
 */

$todd.ObjRadiobutton.onRadiogroupChange = function(control)
{
  var comp = $(control).retrieve("todd");
  if (comp)
  {
    Radiobutton.getRegisteredRadiobuttonsInGroup(comp.radiogroup).each(function(other)
    {
      // Call the onControlChange handler for the other radiobuttons which do not receive an onchange event when unchecked to
      // make enablecomponents work
      if (other != control)
        $(other).retrieve("todd").onControlChange();
    });
    comp.owner.actionEnabler();
  }
};

// ---------------------------------------------------------------------------
//
// Image
//

$todd.ObjImage = new Class(
{ Extends: $todd.ObjLayout
, Properties: [ "action" ]
, componenttype: "image"

, clickable: false
, imgsrc: ''
, imgwidth: 0
, imgheight: 0

  // ---------------------------------------------------------------------------
  //
  // Initialization
  //

, initialize: function(parentcomp, data, replacingcomp)
  {
    this.parent(parentcomp, data, replacingcomp);
    this.buildNode();
    this.updateNode(data);

    this.action = data.action;
    this.unmasked_events = data.unmasked_events || [];
    this.updateClickable();
  }

  // ---------------------------------------------------------------------------
  //
  // Property getters & setters
  //

, updateClickable: function(value)
  {
    var newclickable = this.action || this.unmasked_events.contains('click');
    if (this.clickable != newclickable)
    {
      this.clickable = newclickable;

      this.node.toggleClass("t-image--clickable", this.clickable);
    }
  }

  // ---------------------------------------------------------------------------
  //
  // DOM
  //

  // Build the DOM node(s) for this component
, buildNode: function()
  {
    this.node = domtools.create("div", { className: "t-image"
                                       , on: { click: evt => this.onClick(evt)
                                             }
                                       });
    this.node.set('data-name',this.name);
    if(this.hint)
      this.node.set('title',this.hint);
    this.node.store("todd", this);
  }
, updateNode:function(data)
  {
    if(data.src && data.src == this.imgsrc)
      return;

    //We'll be loading a new promise
    if(this.imgdefer)
    {
      this.imgdefer.reject(new Error("Image cancelled"));
      this.imgdefer=null;
    }

    domtools.empty(this.node);
    if (data.settings)
    {
      this.imgsrc = null;
      this.imgwidth = data.settings.width;
      this.imgheight = data.settings.height;
      //createImage will take care of UI busy flagging
      this.node.appendChild(toddImages.createImage(data.settings.imgname, data.settings.width, data.settings.height, data.settings.color));
      return;
    }

    let imgdefer = dompack.createDeferred();
    let interfacelock = dompack.flagUIBusy();

    let imgnode = domtools.create('img', { style: { opacity: 0 } //hide the image while loading
                                         , on: { load:  event => imgdefer.resolve(this)
                                               , error: error => imgdefer.reject(error)
                                               }
                                         });
    imgdefer.promise.then(imgnode => this.relayout());
    imgdefer.promise.finally( () => interfacelock.release());

    this.imgwidth = data.imgwidth;
    this.imgheight = data.imgheight;
    this.node.appendChild(imgnode);
    imgnode.src = data.src;
  }
  // ---------------------------------------------------------------------------
  //
  // Dimensions
  //

, calculateDimWidth: function()
  {
    this.width.calc = $todd.CalcAbsSize(this.width.xml_set);
    this.width.min = this.width.calc;
    this.debugLog("dimensions", "calc=" + this.width.calc + ", min=" + this.width.min);
  }

, calculateDimHeight: function()
  {
    this.height.calc = $todd.CalcAbsSize(this.height.xml_set);
    this.height.min = Math.max(this.height.calc, $todd.settings.grid_vsize);
    this.debugLog("dimensions", "min=" + this.height.min + ", calc=" + this.height.calc + ", min=" + this.height.min);
  }

, relayout: function()
  {
    this.debugLog("dimensions", "relayouting set width=" + this.width.set + ", set height="+ this.height.set);
    var coords = legacybase.getCoverCoordinates(this.imgwidth, this.imgheight, this.width.set, this.height.set, true);

    this.node.firstChild.setStyles({"width": coords.width
                                  ,"height": coords.height
                                  ,"top": coords.top
                                  ,"margin-left": coords.left
                                  ,"position":"relative"
                                  ,"opacity":"1"
                                  });
  }

  // ---------------------------------------------------------------------------
  //
  // Events & callbacks
  //

, onClick: function(event)
  {
    if(!this.clickable)
      return;

    this.owner.executeAction(this.action);
    if (!this.isEventUnmasked('click'))
      return;

    /*
    scale coordinates up relative to the original size of the image

    NOTE:
    - don't use imgwidth/imgheight, but the natural size (original pixelsize of the image)
    - don't use setwidth and setheight to determine the ratio (only one is forced to a different size)
    */
    console.log( { clientWidth: event.target.clientWidth, clientHeight: event.target.clientHeight, offsetX: event.offsetX, offsetY: event.offsetY, imgwidth: this.imgwidth, imgheight: this.imgheight, wratio, hratio} );
    let pixelratio = window.devicePixelRatio || 1;

    //IE passes coordinates with decimals, even on 1:1 screens..
    let offsetx = Math.round(event.offsetX * pixelratio) / pixelratio;
    let offsety = Math.round(event.offsetY * pixelratio) / pixelratio;
    var wratio = this.imgwidth  / event.target.clientWidth;
    var hratio = this.imgheight / event.target.clientHeight;

    var data = JSON.stringify(
              { absolutex: offsetx
              , absolutey: offsety
              , nativex:   offsetx * wratio  // click position scaled to original image size
              , nativey:   offsety * hratio
              });

    // 2nd argument is to check whether a message of this type is allready in the queue?
    this.queueEvent(this.owner.screenname + '.' + this.name, 'click '+ data, true/*sychronous*/);
  }

, applyUpdate: function(data)
  {
    switch(data.type)
    {
      case 'image':
        this.updateNode(data);
        return;
      case 'action':
        this.action = data.action;
        this.updateClickable();
        return;
      case 'eventmask':
        this.unmasked_events = data.unmasked_events;
        this.updateClickable();
        return;
    }

    this.parent(data);
  }
});


/* Basic HTML5 component wrapper */
$todd.ObjHTMLFieldBase = new Class(
{ Extends: $todd.ObjLayout

, initialize: function(parentcomp, data, replacingcomp)
  {
    this.parent(parentcomp, data, replacingcomp);
  }
, getValue: function()
  {
     return this.node.value || '';
//    return this.obj.getValue() || '';
  }

, setValue: function(value)
  {
    domui.changeValue(this.node, value);
    //shouldn't be needed: this.onSelect(); - changeValue will fire the event itself
  }

, setRequired: function(value)
  {
    if (!!value != !!this.node.required)
    {
     this.node.required = !!value;
     //ADDME? this.node.toggleClass("required", this.required);
     this.node.fireEvent("wh-refresh");
    }
  }

, setEnabled: function(value)
  {
    if (value != !this.node.disabled)
    {
      this.node.disabled = !value;
      this.node.fireEvent("wh-refresh");
    }
  }


, getSubmitValue: function()
  {
    return this.getValue();
  }

, buildNode: function()
  {
    this.node = this.buildHTMLNode();
    if(this.hint)
      this.node.set('title',this.hint);
    this.node.set("data-name", this.name);
    this.node.addEvent("change", this.onSelect.bind(this));
    this.node.store("todd", this);
  }

, onSelect:function()
  {
//    if(this.isEventUnmasked("select"))
    if(this.isEventUnmasked("select") || this.enablecomponents.length)
//      this.queueEvent(this.owner.screenname + "." + this.name, "select", true);
        this.transferState();
    // always call actionEnabled or enableon's and clientside visibleon's won't work correctly
    this.owner.actionEnabler();
  }

});


/****************************************************************************************************************************
 *                                                                                                                          *
 *  PULLDOWN                                                                                                                *
 *                                                                                                                          *
 ****************************************************************************************************************************/


$todd.ObjPulldown = new Class(
{ Extends: $todd.ObjHTMLFieldBase
, componenttype: "pulldown2"
, components: []

/****************************************************************************************************************************
 * Initialization
 */

, initialize: function(parentcomp, data, replacingcomp)
  {
    this.parent(parentcomp, data, replacingcomp);

    this.options = data.options;
    this.options.each(function(opt)
    {
      //ADDME: Should the menu code handle this?
      for (var i = 0; i < opt.indent; ++i)
        opt.title = "\xA0\xA0" + opt.title;
      if (opt.enablecomponents)
        this.enablecomponents.combine(opt.enablecomponents);
    }, this);

    this.buildNode();
    this.setRequired(data.required);
    this.setEnabled(data.enabled);
  }

/****************************************************************************************************************************
 * DOM
 */

, buildHTMLNode: function()
  {
    var node = new Element("select");
    Array.each(this.options, function(opt)
    {
      if(opt.isdivider)
      {
        node.appendChild(new Element("option", { disabled: "disabled"
                                         , "class":  "divider"
                                         , "text":   "──────────"
                                        }));
      }
      else
      {
        node.appendChild(new Element("option", { value: opt.value
                                         , text: opt.title
                                         , selected: opt.selected ? "selected" : null
                                         , disabled: opt.enabled ? null : "disabled"
                                        }));
      }
    });

    return node;
  }

/****************************************************************************************************************************
 * Dimensions
 */

, getSkinSettings:function()
  {
    return { compheight: Math.ceil(this.node.getBoundingClientRect().height) };
  }

, calculateDimWidth: function()
  {
/*    if(!this.myminheight) //first time rendering, the browser will simply tell us our height
    {
      this.myminheight = this.node.getStyle("height").toInt();
      if (!(this.myminheight >= 0))
      {
        console.error("pulldown height style is negative or not a number!", this.myminheight, this.node.getStyle("height"));
        this.myminheight = 32;
      }
    }
*/
    //console.warn("wh-ui-replacedby width: " + this.node.retrieve("wh-ui-replacedby").getSize().x);

//    var highest = 0;
//    var contentwidth = 0;
    /*this.options.each(function(option)
    {
      //console.log(option.title ? option.title : option.value);
      highest = Math.max(contentwidth, $todd.CalculateTextSize(option.title ? option.title : option.value).x);
      //console.log(highest);
      if(highest > contentwidth)
        contentwidth = Math.max(contentwidth, $todd.CalculateTextSize(option.title ? option.title : option.value).x);
    });
*/
//    contentwidth = this.node.getBoundingClientRect().width;// Allow for the arrow

    //console.warn(this.node.getDimensions().x);

    //console.error(contentwidth);

    //contentwidth += 32; //FIXME try to just get the replaced's element width

    //if(this.node.retrieve("wh-ui-replacedby").getSize().x > contentwidth)
    //{
    //  contentwidth = this.node.retrieve("wh-ui-replacedby").getSize().x;
    //  this.width.set = contentwidth;
    //}

    this.width.min = 32; //FIXME determine a value, or don't we want us to ever shrink ?
    this.width.calc = (this.node.retrieve("wh-ui-replacedby") || this.node).getSize().x;
    //console.log(this.width.calc, this.node, this.node.retrieve("wh-ui-replacedby"));
    this.debugLog("dimensions", "calc=" + this.width.calc + ", min=" + this.width.min);
    //console.warn("ObjPulldown.calaculateDimWidth: dimensions", "calc=" + this.width.calc + ", min=" + this.width.min + ", set=" + this.width.set);

    //console.warn("ObjPulldown.calaculateDimWidth: Actual width, set in CSS: " + this.node.getStyle("width"));
    //console.warn("ObjPulldown.calaculateDimWidth: Actual width, calculated: " + this.node.getSize().x);
    //console.warn("ObjPulldown.calaculateDimWidth: Component width, set in CSS: " + this.node.retrieve("wh-ui-replacedby").getStyle("width"));
    //console.warn("ObjPulldown.calaculateDimWidth: Component width, calculated: " + this.node.retrieve("wh-ui-replacedby").getSize().x);
  }

, calculateDimHeight: function()
  {
    this.height.min = Math.max(this.skinsettings.compheight, $todd.settings.grid_vsize);
  }

, relayout: function()
  {
    //console.warn("What we know upon relayout:");
    //console.warn(this.width);
    //alert(this.node.getDimensions().x);
    this.debugLog("dimensions", "relayouting set width=" + this.width.set + ", set height="+ this.height.set);

    // When the assigned width is equal to the absolute minimum, make the pulldown collapsed, causing the title part to be
    // hidden (it will be too small to display the ellipsis anyway)
    var collapsed = this.width.set == this.myminheight;
    //var reset = false;
    //if(this.node.getStyle("width") == "auto")
    //  reset = true;

    (this.node.retrieve("wh-ui-replacedby") || this.node).setStyles({/* "margin-left": this.width.marginbefore
                        , */"width": this.width.set
                        //, "line-height": inputheight
                        })
             .toggleClass("collapsed", collapsed);
  }


/****************************************************************************************************************************
 * Events
 */

, enabledOn: function(checkflags, min, max, selectionmatch)
  {
//    console.log(this.obj.getSelectedIndex());
    var flags = this.options[this.node.selectedIndex].flags;
    return $todd.Screen.checkEnabledFlags([flags], checkflags, min, max, selectionmatch);
  }
});


// ---------------------------------------------------------------------------
//
// §
//

$todd.ObjProgress = new Class(
{ Extends: $todd.ObjLayout
, componenttype: "progress"
, components: []

  // ---------------------------------------------------------------------------
  //
  // Initialization
  //

, initialize: function(parentcomp, data, replacingcomp)
  {
    this.parent(parentcomp, data, replacingcomp);
    this.buildNode();
  }

  // ---------------------------------------------------------------------------
  //
  // DOM
  //

, buildNode: function()
  {
    this.node = new Element("progress", {"data-name": this.name} );
    if(this.hint)
      this.node.set('title',this.hint);
    this.node.store("todd", this);
  }

/****************************************************************************************************************************
 * Dimensions
 */

, calculateDimWidth: function()
  {
    this.width.min = 150;
    this.width.calc = 150;
  }

, calculateDimHeight: function()
  {
    this.height.min = 18;
    this.height.calc = 18;
  }

, relayout: function()
  {
    this.debugLog("dimensions", "relayouting set width=" + this.width.set + ", set height="+ this.height.set);
    this.node.setStyles({ "width": this.width.set, "margin-top": "7px" });
  }

  // ---------------------------------------------------------------------------
  //
  // Communication
  //

, onMsgSetValMax:function(data)
  {
    if(data.max<=0)
    {
      this.node.removeAttribute("value");
    }
    else
    {
      this.node.setAttribute("value", data.value);
      this.node.setAttribute("max", data.max);
    }
  }
});

/****************************************************************************************************************************
 *                                                                                                                          *
 *  SLIDER                                                                                                                  *
 *                                                                                                                          *
 ****************************************************************************************************************************/

$todd.ObjSlider = new Class(
{ Extends: $todd.ObjHTMLFieldBase
, componenttype: "slider"
, components: []

/****************************************************************************************************************************
 * Initialization
 */

, initialize: function(parentcomp, data, replacingcomp)
  {
    this.parent(parentcomp, data, replacingcomp);
    this.min = data.min;
    this.max = data.max;
    this.step = data.step;
    this.orientation = data.orientation;

    this.buildNode();
    this.setValue(data.value);
    this.setRequired(data.required);
    this.setEnabled(data.enabled);
  }

/****************************************************************************************************************************
* DOM
*/

  // Build the DOM node(s) for this component
, buildHTMLNode: function(data)
  {
    var node = new Element("t-slider", { "data-name": this.name
                                       });

    this.inputnode = new Element("input", {/*
                                ,*/ "type"   :  "range"
                                , "min"    : this.min
                                , "max"    : this.max
                                , "step"   : this.step
                                , "orient" : (this.orientation ? this.orientation : 'horizontal')
                                }).inject(node);
    this.inputnode.addEventListener("change", this.onChange.bind(this));
    return node;
/*
    this.inputnode.set('required',data.required ? '' : null);
    this.inputnode.set('readonly',data.enabled ? null : '');*/
  }

, onChange: function()
  {
    if(this.isEventUnmasked("change"))
      this.queueEvent(this.owner.screenname + "." + this.name, "change", true);
  }


/****************************************************************************************************************************
 * Property getters & setters
 */

, setValue:function(newvalue)
  {
    newvalue = [newvalue].flatten();
    this.inputnode.set({ "value"  : (newvalue.length ? newvalue[0] : "") //html5 supports only single value
                       , "data-values" : (newvalue.length ? newvalue.join(',') : '')
                       });
  }

, getSubmitValue: function()
  {
    return this.getValue();
  }

, getValue: function()
  {
    return this.inputnode.get("value");
  }

/****************************************************************************************************************************
 * Component management
 */

/****************************************************************************************************************************
* Dimensions
*/

, calculateDimWidth: function()
  {
    this.width.min = 150;
    this.width.calc = 250;

    //if(this.inputnode.getAttribute('orient') != 'vertical')
    //  this.inputnode.retrieve('wh-ui-replacedby').fireEvent('wh-resized');
  }

, calculateDimHeight: function()
  {
    this.height.min = $todd.settings.grid_vsize * 2;
//    if(this.inputnode.getAttribute('orient') == 'vertical')
  //    this.inputnode.retrieve('wh-ui-replacedby').fireEvent('wh-resized');
  }

, relayout:function()
  {
    this.inputnode.setStyles({ width: this.width.set, height: this.height.set });
    this.inputnode.retrieve('wh-ui-replacedby').fireEvent('wh-resized');
    console.log("Fire on",this.inputnode);
    this.inputnode.fireEvent("wh-refresh");
  }

/****************************************************************************************************************************
 * Events
 */
});


/****************************************************************************************************************************
 *                                                                                                                          *
 *  TAGEDIT                                                                                                                 *
 *                                                                                                                          *
 ****************************************************************************************************************************/

$todd.ObjTagEdit = new Class(
{ Extends: $todd.ObjLayout
, componenttype: "tagedit"
, components: []
, value: ""
, separator: ","
, allowmultiple: false
, casesensitive: false
, placeholder: ""
, autocomplete: null
, restrictvalues: false
, validatetags: false
, validatequeries: []
, validatequerycounter: 0

/****************************************************************************************************************************
 * Initialization
 */

, initialize: function(parentcomp, data, replacingcomp)
  {
    this.parent(parentcomp, data, replacingcomp);
    this.separator = data.separator;
    this.allowmultiple = data.allowmultiple;
    this.casesensitive = data.casesensitive;
    this.placeholder = data.placeholder;
    this.restrictvalues = data.restrictvalues;
    this.validatetags = data.validatetags;
    this.setValue(data.value);

    if (data.ac_port)
      this.autocomplete = new $todd.AutoCompleteService(data);

    // Build our DOM
    this.buildNode();

    this.setRequired(data.required);
    this.setEnabled(data.enabled);
  }

/****************************************************************************************************************************
 * Property getters & setters
 */

, getSubmitValue: function()
  {
    return this.control
        ? { tags:                 this.control.getStringValue()
          , hasunprocessedinput:  this.control.haveUnprocessedInput()
          }
        : { tags:                 this.value
          , hasunprocessedinput:  false
          };
  }

, getValue: function()
  {
    return this.control ? this.control.getStringValue() : this.value;
  }

, setValue: function(value)
  {
    if (value != this.value)
    {
      this.value = value;
      if (this.control)
        this.control.setStringValue(this.value);
    }
  }

, setRequired: function(value)
  {
    if (value != this.required)
    {
      this.required = value;
      this.node.toggleClass("required", this.required);
    }
  }

, setEnabled: function(value)
  {
    if (value != this.enabled)
    {
      this.enabled = value;
      this.node.toggleClass("disabled", !this.enabled);
    }
  }

/****************************************************************************************************************************
* DOM
*/

, buildNode:function()
  {
    this.control = new TagEdit(null, { tagSeparator: this.separator
                                         , allowMultiple: this.allowmultiple
                                         , caseSensitive: this.casesensitive
                                         , placeholder: this.placeholder
                                         , useinput: true
                                         , multiline: true
                                         , validatetags: this.validatetags ? this._validateTags.bind(this) : null
                                         , onChange: function(event) { console.warn('change'); }
                                         });
    this.control.setOptionService(this.autocomplete, this.restrictvalues);
    if (this.value)
      this.control.setStringValue(this.value);
    this.node = $(this.control);
    if(this.hint)
      this.node.set('title',this.hint);
    this.node.set({ "data-name": this.name
                  });
    this.node.store("todd", this);
  }

/****************************************************************************************************************************
 * Component management
 */

, calculateDimWidth: function()
  {
    this.width.overhead = 0;//$wh.getHorizontalOverhead(this.node);
    this.width.min = $todd.desktop.x_width*2 + this.width.overhead;
    this.width.calc = 150;
  }

, calculateDimHeight: function()
  {
    this.height.overhead = 0;//$wh.getVerticalOverhead(this.node);
    this.height.min = 23;
    this.height.calc = 23;
  }

 , relayout: function()
   {
     this.debugLog("dimensions", "relayouting set width=" + this.width.set + ", set height="+ this.height.set);
     this.node.setStyles({ width: this.width.set// - this.width.overhead
                         , height: 23
                         // , "margin-left": this.width.marginbefore
                         , "margin-top": this.getVerticalPosition()
                         });
   }


/****************************************************************************************************************************
 * Callbacks
 */

, _validateTags: function(tags)
  {
    ++this.validatequerycounter;
    this.queueMessage('validatetags', { tags: tags, msgid: this.validatequerycounter }, true);

    var defer = dompack.createDeferred();
    this.validatequeries.push({ msgid: this.validatequerycounter, defer: defer });
    return defer.promise;
  }

, onMsgValidateTagsReply:function(data)
  {
    for (var i = 0; i < this.validatequeries.length; ++i)
    {
      if (this.validatequeries[i].msgid == data.replyto)
      {
        this.validatequeries[i].defer.resolve(data.tags);
        this.validatequeries.splice(i, 1);
        return;
      }
    }
  }

});


/****************************************************************************************************************************
 *                                                                                                                          *
 *  CUSTOM HTML                                                                                                             *
 *                                                                                                                          *
 ****************************************************************************************************************************/

$todd.ObjCustomHTML = new Class(
{ Extends: $todd.ObjLayout
, componenttype: "custom"

, selectionflags: []

/****************************************************************************************************************************
 * Initialization
 */

, initialize: function(parentcomp, data, replacingcomp)
  {
    this.parent(parentcomp, data, replacingcomp);

    this.node = new Element("t-custom", { "data-name": this.name
                                        , "styles": { "position": "relative"
                                                    , "overflow": "hidden"
                                                    }
                                        });
    this.contentdiv = new Element("div", { "styles": { "width": "100%"
                                                     , "height": "100%"
                                                     }}).inject(this.node);
    this.node.store("todd", this);
  }

/****************************************************************************************************************************
 * Property getters & setters
 */

, getContainer: function()
  {
    return this.contentdiv;
  }

, setSelectionFlag: function(flag)
  {
    this.selectionflags.include(flag);
    this.owner.actionEnabler();
  }

, clearSelectionFlag: function(flag)
  {
    this.selectionflags.erase(flag);
    this.owner.actionEnabler();
  }

/****************************************************************************************************************************
 * Dimensions
 */

, calculateDimWidth: function()
  {
  }

, calculateDimHeight: function()
  {
  }

, relayout: function()
  {
    this.node.setStyles({"width": this.width.set
                        ,"height": this.height.set
                        });
    if (this.width.set != this.prevwidth || this.height.set != this.prevheight)
    {
      this.prevwidth = this.width.set;
      this.prevheight = this.height.set;

      this.fireEvent.delay(0, this, [ "resized", { target: this, x: this.width.set, y: this.height.set } ]);
    }
  }

/****************************************************************************************************************************
 * Events
 */

, applyUpdate: function(data)
  {
    switch(data.type)
    {
/*
      case 'unmasked_events':
        this.unmasked_events = data.unmasked_events;
        return;
*/
    }

    this.parent(data);
  }

, enabledOn: function(checkflags, min, max, selectionmatch)
  {
    return $todd.Screen.checkEnabledFlags(this.selectionflags, checkflags, min, max, selectionmatch);
  }
});



/****************************************************************************************************************************
 *                                                                                                                          *
 *  CUSTOM HTML                                                                                                             *
 *                                                                                                                          *
 ****************************************************************************************************************************/

$todd.ObjHr = new Class(
{ Extends: $todd.ObjLayout
, componenttype: "hr"

/****************************************************************************************************************************
 * Initialization
 */

, initialize: function(parentcomp, data, replacingcomp)
  {
    this.parent(parentcomp, data, replacingcomp);
    this.node = new Element("t-hr", { "data-name": this.name
                                    });
    this.node.store("todd", this);
  }

/****************************************************************************************************************************
 * Dimensions
 */

, calculateDimWidth: function()
  {
  }

, calculateDimHeight: function()
  {
    this.height.min = $todd.settings.grid_vsize;
  }

, relayout: function()
  {
    this.node.setStyles({ "height": this.height.set });
  }
});



/****************************************************************************************************************************
 * Export the components
 */
exports.components = { text: $todd.ObjText
                     , textedit: $todd.ObjTextEdit
                     , combobox: $todd.ObjTextEdit
                     , datetime: $todd.ObjDateTime
                     , textarea: $todd.ObjTextArea
                     , button: $todd.ObjButton
                     , checkbox: $todd.ObjCheckbox
                     , radiobutton: $todd.ObjRadiobutton
                     , image: $todd.ObjImage
                     , pulldown: $todd.ObjPulldown
                     , progress: $todd.ObjProgress
                     , slider: $todd.ObjSlider
                     , tagedit: $todd.ObjTagEdit
                     , customhtml: $todd.ObjCustomHTML
                     , hr: $todd.ObjHr
                     };

//note, we'll need to replace inputs by class, as unsupported types will have been dropped (eg input[type-date] won't match)
//$wh.Pulldown2.replaceComponents("select");
DateField.replaceComponents("input.date", { });
TimeField.replaceComponents("input.time");
Slider.replaceComponents('input[type=range]', { resizelistener : true });



// WEBPACK FOOTER //
// /opt/wh/whtree/modules/tollium/web/ui/js/fields.es